import React, {Component} from 'react';

import { connect } from 'react-redux'
import LikelyCloses from './components/LikelyCloses/LikelyCloses'

import {
  fetchSlimAccount, fetchLikelyCloses
} from 'broker/redux/account'
import { UNIVERSAL_EXPORT_TIMEFRAME_MONTH } from 'common/constants'
import {getAuthEmail} from "broker/util/downloader";


const mapDispatchToProps = dispatch => ({
    dispatch
})

class LikelyClosesContainer extends Component {

    constructor(props) {
      super(props)
    }

    componentWillMount() {
      const { dispatch, account } = this.props
      dispatch(fetchLikelyCloses(UNIVERSAL_EXPORT_TIMEFRAME_MONTH, false, null))
      dispatch(fetchSlimAccount())
    }

    render() {
      return <LikelyCloses {...this.props} />
    }
}

export default connect((state) => ({ account: state.account, auth: state.auth, email: getAuthEmail(state), root: state.root}), mapDispatchToProps)(LikelyClosesContainer)
